module.exports = __webpack_public_path__ + "img/ic_16_star-2.2c013c84.svg";